<template>
  <div class="mt-4" align="justify">
    <div v-if="serviceFailure">
      <b-alert show variant="danger">{{ message }}</b-alert>
    </div>
    <div v-else-if="noDataFound">
      <b-alert show variant="danger">{{ noDataMsg }}</b-alert>
    </div>
    <div v-else>
      <div class="text-center text-primary my-2" v-if="isBusy">
        <b-spinner class="align-middle"></b-spinner>
        <strong>Loading...</strong>
      </div>
      <div id="mainContent" v-else>
        <div>
          <h1>{{ story.name }}</h1>
        </div>
        <div id="section" v-html="story.content"></div>
      </div>
    </div>

    <div class="my-4">
      <b-button variant="outline-primary" :href="`?reportName=story`"
        >Go Back To Story List</b-button
      >
    </div>
  </div>
</template>
<script>
import { data } from "@/shared";
import { SERVICE_UNAVAILABLE_ERROR_MSG } from "@/shared/config.js";
import { SERVICE_NO_DATA_MSG } from "@/shared/config.js";
export default {
  name: "StoryReportDetails",
  data() {
    return {
      story: [],
      isBusy: false,
      message: SERVICE_UNAVAILABLE_ERROR_MSG,
      noDataMsg: SERVICE_NO_DATA_MSG,
      serviceFailure: false,
      noDataFound: false
    };
  },
  props: {
    footerurl: String,
    id: Number
  },
  async created() {
    if (this.id) {
      await this.getStoryReportDetailsData();
    }
  },

  methods: {
    async getStoryReportDetailsData() {
      this.story = [];
      this.isBusy = true;
      this.story = await data.getStoryById(this.id);

      if (this.story instanceof Error) {
        if (this.story.response.status === 404) {
          this.noDataFound = true;
        } else  this.serviceFailure = true;
      }
      this.isBusy = false;
    }
  }
};
</script>
<style>
div.articlephoto {
  width: auto;
  float: right;
  border: 1px solid #ebebeb;
  margin-left: 12px;
  margin-bottom: 12px;
  padding-top: 10px;
  padding-right: 10px;
  padding-bottom: 10px;
  padding-left: 10px;
  height: auto;
}
.bold {
  font-weight: bold;
}
.italic {
  font-style: italic;
}
p.credit1, p.credit {
    width: 100%;
    clear: both;
    border-top: 1px solid #dcdcdc;
    padding-top: 15px;
    padding-bottom: 15px;
}
p.credit {
    border-bottom: 1px solid #dcdcdc;
}
.underline {
    text-decoration: underline;
}
</style>
